<template>
   <div class="calc-types" v-if="types">
        <button type="button" v-for="itemType in types" @click="setType(itemType.id)" class="calc-types-item" :class="{'--acitve':type == itemType.id}"><span>{{itemType.name}}</span></button>
    </div>

    <div class="calc-steps" v-if="itemFiltered.length">
        <div class="calc-step" v-for="product in itemFiltered">
            <a :href="createHref(product.id, product.type_id)" class="calc-step-container" >
                <div class="calc-step-image">
                    <img :src="product.image?.src " :alt="product.name">
                </div>
                <div class="calc-step-title">{{product.name}}</div>
            </a>
        </div>
    </div>
</template>

<script setup async>

    import useApi from "@/composables/useApi";
    import {ref, computed, onMounted, watch} from "vue";

    let {loadProducts, loadProductTypes} = useApi();

    let type = ref(1);
    let items = ref([]);
    let types = ref([]);
    let loadItems = async () => {
        items.value = await loadProducts();
        types.value = await loadProductTypes();
    }

    const itemFiltered = computed(() => items.value.filter(i => i.type_id == type.value))

    const createHref = (id, type_id) => `?product_id=${id}&type_id=${type_id}`
    const setType = (id) => {
        type.value = id;
        setParam('type_id', id)
    };
    const setParam = (key, value) => {
        const url = new URL(window.location.href)
        url.searchParams.set(key, value)
        window.history.pushState({}, '', url)
    }
    const getParam = (key) => {
        return new URLSearchParams(window.location.search).get(key)
    }
    onMounted(async () => {
        await loadItems();
        const allowedTypes = types.value.map(i => i.id);
        const type_id = getParam('type_id');
        type.value = allowedTypes.includes(type_id) ? type_id : allowedTypes[0];

    });

</script>

<style lang="scss">

.calc-types{
    display: flex;
    gap: 10px;
    margin-bottom: 1rem;
}

.calc-types .calc-types-item{
    cursor: pointer;
    border: none;
    padding: 10px 2rem;
    color: #000;
    font-weight: 500;
}

.calc-types .calc-types-item:hover{
    background: var(--f-button-hover-bg);
}

.calc-types .calc-types-item.--acitve{
    background: #d5ef28;
}

.calc-steps{
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));

    .calc-step{
        position: relative;
        background: #f8f8f8;
        text-align: center;
        display: block;
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #dfdfdf;
        transition: 100ms box-shadow;
        overflow: hidden;
        height: 100%;
        cursor: pointer;
        border-radius: 10px;
    }
    .calc-step:hover{
        background: linear-gradient(0deg, #d5ef28, #aec517);
        border: 1px solid #d5ef28;
    }

    .calc-step:hover .calc-step-image{
        transform: scale(1.02);
    }



    .calc-step-container{
        text-decoration: none;
        color: #000;
        padding: 2rem;
        display: block;
    }




    .calc-step-image{
        display: block;
        margin: 0 auto 1rem;
        transition: 200ms;
    }

    .calc-step-image img{
width: 100%;
    display: block;
    aspect-ratio: 1;
    margin: 0 auto 1rem;
    max-width: 240px;
    --bloack: #0000001f;
    filter: drop-shadow(0px 4px 8px var(--bloack));
    object-fit: scale-down;
    }
    .calc-step-title{
        text-align: center;
    }

    .calc-step-title{
        text-transform: uppercase;
        font-weight: 500;
    }

}

</style>